import type { ITopicsSDK } from '@1js/cortex-topics-bootstrapper';

let topicsSdk: ITopicsSDK | undefined;

/**
 * Returns the Topics SDK if it's been initialized.
 * It may return undefined, so these cases need to be accounted for.
 *
 * For usage outside this package, please use the owa-topic-common version.
 */
export function tryGetTopicsSdk(): ITopicsSDK | undefined {
    return topicsSdk;
}
export function setTopicsSdk(sdk: ITopicsSDK): void {
    topicsSdk = sdk;
}
